import type { ComponentPropsWithoutRef } from 'react';
import { styled } from 'styled-components';
import { Typography, tk } from '@sunwebgroup/ui-components';

export function FooterBlock({ children, ...attrs }: ComponentPropsWithoutRef<'section'>) {
  return <section {...attrs}>{children}</section>;
}

interface FooterBlockHeaderProps extends ComponentPropsWithoutRef<'h3'> {
  href?: string;
}

export function FooterBlockHeader({ children, href, ...attrs }: FooterBlockHeaderProps) {
  return (
    <StyledHeader $variant="body-lg-bold" as="h3" {...attrs}>
      {href && <ItemLink href={href} />}
      {children}
    </StyledHeader>
  );
}

const StyledHeader = styled(Typography)`
  margin-bottom: ${tk('spacing_xs')};
  position: relative;
`;

const ItemLink = styled.a`
  height: 100%;
  position: absolute;
  width: 100%;
`;
